(function() {
  var Router, Storage,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Router = App.loadClass('core::Router');

  Storage = App.loadClass('core::Storage');

  exports.DataRouter = (function(superClass) {
    extend(DataRouter, superClass);

    function DataRouter() {
      return DataRouter.__super__.constructor.apply(this, arguments);
    }

    DataRouter.prototype.prefix = 'Data';

    DataRouter.prototype.module_name = 'DataRouter';

    DataRouter.prototype.register = function() {
      this.module = angular.module(this.module_name, ['ui.router', 'ui.bootstrap']);
      this.module.filter('fieldFilter', function() {
        return function(collection, text) {
          var farm_name, field, field_name, j, len, list;
          if (text === '') {
            return collection;
          }
          list = [];
          text = text.toLowerCase();
          for (j = 0, len = collection.length; j < len; j++) {
            field = collection[j];
            farm_name = field.farm_name.toLowerCase();
            field_name = field.field_name.toLowerCase();
            if (farm_name.indexOf(text) !== -1 || field_name.indexOf(text) !== -1) {
              list.push(field);
            }
          }
          return list;
        };
      });
      this.module.filter('yearFilter', function() {
        return function(collection, text) {
          var j, len, list, year;
          if (text === '') {
            return collection;
          }
          list = [];
          for (j = 0, len = collection.length; j < len; j++) {
            year = collection[j];
            year = year.toString();
            if (year.indexOf(text) !== -1) {
              list.push(year);
            }
          }
          return list;
        };
      });
      this.module.filter('numFilter', function() {
        return function(collection, text) {
          var i, j, len, list, num;
          if (text === '') {
            return collection;
          }
          list = [];
          for (i = j = 0, len = collection.length; j < len; i = ++j) {
            num = collection[i];
            num = num.toString();
            if (num.indexOf(text) !== -1) {
              list.push(num);
            }
          }
          return list;
        };
      });
      this.service('grower::Angular/Data/Services/DataSidebarService', ['$http', '$rootScope', 'Core.Services.Loading']);
      this.service('grower::Angular/Data/PlantingRx/Services/LegendService', ['$rootScope']);
      this.service('grower::Angular/Data/Services/LegacyHandlerService', ['$rootScope', '$timeout', 'Data.Services.LegendService']);
      this.service('grower::Angular/Data/Services/UserSelectionService', ['$rootScope']);
      this.service('grower::Angular/Data/Services/DownloadService', ['$http', '$window', '$uibModal']);
      this.service('grower::Angular/Data/Add/Maps/Upload/Conversion/Services/MapsConversionService', ['$http', '$rootScope', '$window']);
      this.controller('grower::Angular/Data/ViewController', ['$state', '$scope', '$transitions', 'Data.Services.DataSidebarService', '$window', 'Data.Services.LegacyHandlerService', '$uibModal', 'Data.Services.UserSelectionService', 'Core.Services.Loading', 'Data.Services.DownloadService', '$stateParams', '$q', '$ngModal', '$http']);
      this.controller('grower::Angular/Data/Add/AddController', ['$scope', '$transitions', 'Data.Services.DataSidebarService', 'Data.Services.LegacyHandlerService', '$state', 'Data.Services.UserSelectionService', '$ngModal', '$http']);
      this.controller('grower::Angular/Data/IrrigationDetailsController', ['$scope', '$transitions', '$transition$', '$uibModalInstance', 'FieldsDefine.Services.IrrigationDetails', '$q', '$ngModal']);
      return this.controller('grower::Angular/Fields/FieldDetailsController', ['$scope', '$http', '$transitions', '$transition$', '$uibModalInstance', '$q', '$rootScope']);
    };

    DataRouter.prototype.registerRoutes = function($stateProvider) {
      return $stateProvider.modalState('grower.data.view.irrigation-details', {
        url: '/irrigation-details/:layer_id/:year/:field_id',
        templateUrl: 'backend/grower/data/irrigation-details',
        controller: 'Data.Controllers.IrrigationDetailsController',
        windowClass: 'small_dialog'
      }).modalState('grower.data.view.field-details', {
        url: '/field-details/:id/:year/:editing',
        templateUrl: 'backend/grower/fields/field-details-view',
        controller: 'Fields.Controllers.FieldDetailsController',
        windowClass: 'small_dialog'
      });
    };

    return DataRouter;

  })(Router);

}).call(this);
